import expiredSession from "./expired-session.json";
import login from "./login.json";
import forgotPassword from "./forgot-password.json";
import recoveryPassword from "./recovery-password.json";
import errors from "./errors.json";
import actions from "./actions.json";
import confirmMessages from "./confirm-messages.json";
import labels from "./labels.json";
import noAuth from "./no-auth.json";
import paymentLinkCallback from "./payment-link-callback.json";

export const noAuthEN = {
	...noAuth,
	paymentLinkCallback,
	expiredSession,
	login,
	forgotPassword,
	recoveryPassword,
	errors,
	actions,
	confirmMessages,
	labels,
};
